// external imports
import React from 'react'
import { createFragmentContainer, graphql } from 'react-relay'
import { FlexColumn, Title, Subtitle, BooleanState } from 'quark-web'
import { withRouter } from 'react-router-dom'
// local imports
import { Text, ProductUrl } from '~/components'
import styles from './styles'

const SearchResult = ({ product, history }) => (
    <BooleanState>
        {({ state, set }) => (
            <ProductUrl product={product}>
                {url => (
                    <FlexColumn
                        style={styles.container}
                        onMouseEnter={() => set(true)}
                        onMouseLeave={() => set(false)}
                        onClick={() => history.push(url)}
                    >
                        <Title style={styles.productName}>{product.name}</Title>
                        <Subtitle style={styles.productDescription}>{product.description}</Subtitle>
                        <Text style={state && styles.productLinkActive}>Read More</Text>
                    </FlexColumn>
                )}
            </ProductUrl>
        )}
    </BooleanState>
)

export default createFragmentContainer(
    withRouter(SearchResult),
    graphql`
        fragment SearchResult_product on Product {
            name
            description
            ...ProductUrl_product
        }
    `
)



// WEBPACK FOOTER //
// ./src/views/Search/SearchResult/index.js